<template>
	<c-dialog ref="dialog" width="450" @resolve="editHandle">
		<c-form ref="form" vertical unit-width="100%">
			<c-input type="hidden" name="dic_id"></c-input>
			<c-input type="hidden" name="id"></c-input>
			<c-form-item label="字典值" required>
				<c-input name="value" maxlength="50"></c-input>
			</c-form-item>
			<c-form-item label="报销项类型" v-show="dic_id == 4">
                <c-select name="kind" :options="expenseItemTypeDic"></c-select>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
import {mapState} from "vuex";

export default {
	data() {
		return {
            dic_id:0,
            dic_name:''
		}
	},
    computed: {
        ...mapState(['expenseItemTypeDic'])
    },
	methods: {
		/*********打开编辑框，初始化**********/
		open(data) {
			this._editState = !!data.id;
            this.$refs.form.clear();
            if (data) {
                if (data.config_json){
                    data = Object.assign(data,data.config_json);
                }
                this.dic_id = data.dic_id;
                this.dic_name = data.dic_name;
                this.$refs.form.set(data);
			}
			//填充form表单
            const title = (this._editState ? '编辑' : '添加')+'【'+this.dic_name+'】'+'字典值';
			this.$refs.dialog.open({
				title:title
			});
		},

		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: this._editState?'/operation/dic/detail/edit':'/operation/dic/detail/add',
				rule: {
                    value: '请输入字段值'
				},
				dataFormatter: data => {
                    //表单自定义字段
                    if (data.kind){
                        const config_json = {"kind":data.kind};
                        data.config_json = config_json;
                        // data.config_json = JSON.stringify(config_json);
                    }
					return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						message: '提交成功',  // 提示内容,
						type: 'success'
					});
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>